import React from "react";
import { Box, Paper } from "@mui/material";
import { PAGE_BG } from "../../theme/tokens";

export interface PageContainerProps {
  children: React.ReactNode;
  /** Skip the inner Paper wrapper if a page already supplies its own card surface. */
  disablePaper?: boolean;
  /** Extra sx applied to the outer Box (e.g. to override padding). */
  sx?: any;
}

/**
 * Standard premium page wrapper.
 *
 * Drop-in usage:
 *   <PageContainer>
 *     ...page content...
 *   </PageContainer>
 *
 * For pages that manage their own card sections (e.g. Restaurants list with
 * its own Paper-wrapped table), pass `disablePaper` to skip the inner Paper.
 */
export default function PageContainer({ children, disablePaper, sx }: PageContainerProps) {
  return (
    <Box
      sx={{
        padding: { xs: "12px", md: "20px" },
        backgroundColor: PAGE_BG,
        minHeight: "100vh",
        ...sx,
      }}
    >
      {disablePaper ? (
        children
      ) : (
        <Paper
          sx={{
            padding: { xs: "12px", md: "16px" },
            borderRadius: "12px",
            boxShadow: "0 4px 12px rgba(0,0,0,0.06)",
          }}
        >
          {children}
        </Paper>
      )}
    </Box>
  );
}
